export default class Header {
    constructor() {
        this.header = document.querySelector('header');
        this.btMenuMobile = this.header.querySelector('.menuMobile')
        this.menu = this.header.querySelector('.menu');

        this.ready();
    }

    ready() {
        if (this.btMenuMobile) {
            this.btMenuMobile.addEventListener(
                'click',
                () => {
                    this.btMenuMobile.classList.toggle('active');
                    this.menu.classList.toggle('active');
                },
                false
            );
        }
    }
}